import React from 'react';

/**
 * Appkit 4 "copy-outline" icon, inlined as a React component so it can be
 * recolored via `currentColor` and styled with CSS.
 *
 * Source: Appkit4 icon set (Icon/Outline/copy-outline). The original
 * `fill="#474747"` has been replaced with `currentColor`.
 *
 * @param {React.SVGProps<SVGSVGElement>} props
 */
export default function CopyOutlineIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      role="img"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g
        transform="translate(2, 0)"
        fill="currentColor"
        fillRule="nonzero"
      >
        <path d="M14.8746292,0 L19.737671,5.40868171 L19.737671,19.2 L14.9376,19.1988 L14.937671,24 L0,24 L0,4.8 L4.8,4.8 L4.8,0 L14.8746292,0 Z M9.11197932,5.9224 L1.203589,5.922 L1.203989,22.8254195 L13.8144,22.8246195 L13.815271,10.9182211 L9.11197932,10.9182211 L9.11197932,5.9224 Z M13.9119793,1.1224 L5.9224,1.1224 L5.922,4.8 L10.0746292,4.8 L14.937671,10.2086817 L14.9376,18.0768 L18.615271,18.0776 L18.615271,6.11822109 L13.9119793,6.11822109 L13.9119793,1.1224 Z M10.2343793,6.39335158 L10.2343793,10.0904252 L13.2634071,10.0904252 L10.2343793,6.39335158 Z M15.0343793,1.59335158 L15.0343793,5.29042515 L18.0634071,5.29042515 L15.0343793,1.59335158 Z" />
      </g>
    </svg>
  );
}
